//#region IMPORT
import React, { useState, useEffect } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import { LAN_BASIC } from './index';
import { Loading, Snackbar } from '../../../../Components/MUIs';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { useDispatch } from 'react-redux';
import useActionLog from '../../../../hooks/useActionLog';
import { useSelector } from 'react-redux';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'Language';

function LAN_BASICF() {
  useEffect(() => {
    Init();
  }, []);
  //#region 변수
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  //로그 관련
  const { SaveActionLog } = useActionLog();

  const [rowData, setRowData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [changedRowData, setChangedRowData] = useState([]);
  const [excelRowData, setExcelRowData] = useState([]);
  const [inputs, setInputs] = useState({
    mapFile: '',
    mapFileName: '',
    header: [],
    excelData: [],
  });

  //공통코드 리스트
  const [codeList, setCodeList] = React.useState([]);
  const [codeList2, setCodeList2] = useState([]); //code list
  //#endregion
  //#region 조회
  // 공통 코드 조회
  const SearchCode = async () => {
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GetCode',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data.length === 0) {
          setCodeList2([]);
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          throw new Error(data[0].message);
        } else {
          setCodeList2(data);
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
    }
  };

  //조회 버튼(그리드)
  const SearchLogic1 = async () => {
    setLoading(true);
    try {
      Commons.Axios('post', Global.base.useUrl + Global.urls.Execute.execute, [
        {
          procedureName: 'SP_LAN_BASIC_R1',
        },
      ]).then((result) => {
        let data = result.data;
        if (data.type === 'Error') {
          throw new Error(data.message);
        } else if (data.length === 0) {
          setRowData([]);
        } else {
          setRowData(Commons.InsertNumber(data));
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 저장
  //저장버튼 클릭 시 함수(웹)
  const SaveLogic1 = async () => {
    setLoading(true);
    let saveData = [];
    try {
      if (
        !changedRowData ||
        changedRowData == null ||
        changedRowData.length === 0
      ) {
        setSnackbar({
          open: true,
          type: 'warning',
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) =>
                    f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'PleaseSelectAnItem'
                ).LAN_NM, //항목을 선택하세요.
        });
        return false;
      } else {
        Commons.Deduplication(changedRowData).forEach((item, index) => {
          if (item.lanId == null || !item.lanId || item.lanId == undefined) {
            throw {
              message:
                lanInfo.length == 0
                  ? ''
                  : lanInfo.find(
                      (f) =>
                        f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'LanguageRequired'
                    ).LAN_NM, //언어 ID는 필수 입력입니다.,
              type: 'warning',
              code: 'CUSTOM_ERROR',
            };
          } else if (
            item.lanCd == null ||
            !item.lanCd ||
            item.lanCd == undefined
          ) {
            throw {
              message:
                lanInfo.length == 0
                  ? ''
                  : lanInfo.find(
                      (f) =>
                        f.LAN_TYPE !== 'MENU' &&
                        f.LAN_ID === 'LanguageCodeRequired'
                    ).LAN_NM, //언어 코드는 필수 입력입니다.,
              type: 'warning',
              code: 'CUSTOM_ERROR',
            };
          } else {
            saveData.push({
              procedureName: 'SP_LAN_BASIC_U1',
              value1: Commons.EncryptAES(item.lanId) || '',
              value2:
                Commons.EncryptAES(
                  codeList2.find(
                    (e) => e.groupCd === 'LAN_CD' && e.codeNm === item.lanCd
                  )
                    ? codeList2.filter(
                        (e) => e.groupCd === 'LAN_CD' && e.codeNm === item.lanCd
                      )[0].code
                    : codeList.filter(
                        (e) => e.groupCd === 'LAN_CD' && e.codeNm === item.lanCd
                      )[0].code
                ) || '',
              value3: Commons.EncryptAES(item.lanNm) || '',
              value4: Commons.EncryptAES(item.lanType) || '',
            });
          }
        });
        const result = await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        );
        const data = result.data;

        if (data.length === 0) {
          dispatch(
            showSnackbar({
              message: '저장 후 반환된 값이 없습니다.',
              type: 'error',
            })
          );
          return;
        } else if (data?.[0]?.type === 'Error') {
          dispatch(
            showSnackbar({
              message: data[0].message || '에러가 발생했습니다.',
              type: 'error',
            })
          );
          return;
        } else {
          setChangedRowData([]);
          setSelectedRowData([]);
          setSnackbar({
            open: true,
            type: 'success',
            message:
              lanInfo.length === 0
                ? ''
                : lanInfo.find(
                    (f) =>
                      f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ItHasBeenSaved'
                  ).LAN_NM, //저장되었습니다.
          });

          // 정상 완료 시 로그
          await SaveActionLog([...changedRowData], {
            menuId: SCREEN_MENU_ID,
            coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
            userId: userInfo.userid,
            logResult: 'SUCCESS',
          });

          await SearchLogic1();

          setInputs({
            ...inputs,
            excelData: [],
            header: [],
            mapFiles: '',
            mapFileName: '',
          });
        }
      }
    } catch (e) {
      // 오류 시 로그
      await SaveActionLog([...changedRowData], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'ERROR',
        errorMsg: e.message,
      });

      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  //저장버튼 클릭 시 함수(모바일)
  const SaveLogic2 = async (_item) => {
    setLoading(true);
    let saveData = [];
    try {
      if (!_item.lanId) {
        setSnackbar({
          open: true,
          type: 'warning',
          message:
            lanInfo.length == 0
              ? ''
              : lanInfo.find(
                  (f) =>
                    f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'LanguageRequired'
                ).LAN_NM, //언어 ID는 필수 입력입니다.
        });
        return false;
      } else if (!_item.lanCd) {
        setSnackbar({
          open: true,
          type: 'warning',
          message:
            lanInfo.length == 0
              ? ''
              : lanInfo.find(
                  (f) =>
                    f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'LanguageCodeRequired'
                ).LAN_NM, //언어 코드는 필수 입력입니다.
        });
        return false;
      } else {
        saveData.push({
          procedureName: 'SP_LAN_BASIC_U1',
          value1: Commons.EncryptAES(_item.lanId) || '',
          value2:
            Commons.EncryptAES(
              codeList2.find(
                (e) => e.groupCd === 'LAN_CD' && e.codeNm === _item.lanCd
              )
                ? codeList2.filter(
                    (e) => e.groupCd === 'LAN_CD' && e.codeNm === _item.lanCd
                  )[0].code
                : _item.lanCd
            ) || '',
          value3: Commons.EncryptAES(_item.lanNm) || '',
          value4: Commons.EncryptAES(_item.lanType) || '',
        });
        if (saveData.length > 0) {
          const result = await Commons.Axios(
            'post1',
            Global.base.useUrl + Global.urls.Execute.execute,
            saveData
          );
          const data = result.data;

          if (data.length === 0) {
            dispatch(
              showSnackbar({
                message: '저장 후 반환된 값이 없습니다.',
                type: 'error',
              })
            );
            return;
          } else if (data?.[0]?.type === 'Error') {
            dispatch(
              showSnackbar({
                message: data[0].message || '에러가 발생했습니다.',
                type: 'error',
              })
            );
            return;
          } else {
            setChangedRowData([]);
            setSelectedRowData([]);
            setSnackbar({
              open: true,
              type: 'success',
              message:
                lanInfo.length == 0
                  ? ''
                  : lanInfo.find(
                      (f) =>
                        f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ItHasBeenSaved'
                    ).LAN_NM, //저장되었습니다.
            });
            SearchLogic1(); //다시 조회
            setInputs({
              ...inputs,
              excelData: [],
              header: [],
              mapFiles: '',
              mapFileName: '',
            });
          }
        }
      }
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 삭제
  //삭제버튼 클릭 시 함수(웹)
  const DeleteLogic1 = () => {
    let deleteData = [];
    if (
      !selectedRowData ||
      selectedRowData == null ||
      selectedRowData.length == 0
    ) {
      setSnackbar({
        open: true,
        type: 'warning',
        message:
          lanInfo.length == 0
            ? ''
            : lanInfo.find(
                (f) =>
                  f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'PleaseSelectAnItem'
              ).LAN_NM, //항목을 선택하세요.
      });
      return false;
    }
    selectedRowData.forEach((item, index) => {
      deleteData.push({
        procedureName: 'SP_LAN_BASIC_D1',
        value1: Commons.EncryptAES(item.lanId) || '',
        value2:
          Commons.EncryptAES(
            codeList2.filter(
              (e) => e.groupCd === 'LAN_CD' && e.codeNm === item.lanCd
            )[0].code
          ) || '',
      });
    });

    Commons.Axios(
      'post1',
      Global.base.useUrl + Global.urls.Execute.execute,
      deleteData
    ).then(async (result) => {
      let data = result.data[0];
      if (data.type === 'Error') {
        throw new Error(data.message);
      } else {
        setChangedRowData([]);
        setSelectedRowData([]);
        setSnackbar({
          open: true,
          type: 'success',
          message:
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) =>
                    f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ItHasBeenDeleted'
                ).LAN_NM, //삭제되었습니다.
        });
        SearchLogic1();
      }
    });
  };

  //삭제버튼 클릭 시 함수(모바일)
  const DeleteLogic2 = async (_lanId, _lanCd) => {
    setLoading(true);
    try {
      if (!_lanId || !_lanCd) {
        return false;
      }

      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_LAN_BASIC_D1',
            value1: Commons.EncryptAES(_lanId) || '',
            value2:
              Commons.EncryptAES(
                codeList2.filter(
                  (e) => e.groupCd === 'LAN_CD' && e.codeNm === _lanCd
                )[0].code
              ) || '',
          },
        ]
      ).then(async (result) => {
        let data = result.data[0];
        if (data.type === 'Error') {
          throw new Error(data.message);
        } else {
          setChangedRowData([]);
          setSelectedRowData([]);
          setSnackbar({
            open: true,
            type: 'success',
            message:
              lanInfo.length === 0
                ? ''
                : lanInfo.find(
                    (f) =>
                      f.LAN_TYPE !== 'MENU' && f.LAN_ID === 'ItHasBeenDeleted'
                  ).LAN_NM, //삭제되었습니다.
          });
          SearchLogic1(); //다시 조회
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 나머지 함수
  const Init = async () => {
    setLoading(true);
    try {
      await SearchCode();

      Commons.Axios('post', Global.base.useUrl + Global.urls.Execute.execute, [
        {
          procedureName: 'SP_GetCode',
        },
      ]).then((result) => {
        let data = result.data;
        data.forEach((item, index) => {
          item.codeNm =
            lanInfo.length === 0
              ? ''
              : lanInfo.find(
                  (f) => f.LAN_TYPE === 'CODE' && f.LAN_ID === 'CD_' + item.code
                )?.LAN_NM;
        });
        setCodeList(data);
      });
      SearchLogic1();
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <LAN_BASIC
        userInfo={userInfo}
        lanList={lanInfo}
        rowData={rowData}
        setRowData={setRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        excelRowData={excelRowData}
        setExcelRowData={setExcelRowData}
        //addClick={addClick}
        SaveLogic1={SaveLogic1}
        SaveLogic2={SaveLogic2}
        DeleteLogic1={DeleteLogic1}
        DeleteLogic2={DeleteLogic2}
        SearchLogic1={SearchLogic1}
        inputs={inputs}
        setInputs={setInputs}
        codeList={codeList}
        codeList2={codeList2}
        setCodeList={setCodeList}
        setSnackbar={setSnackbar}
      />
      <Loading open={loading} />
      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        type={snackbar.type}
        onClose={() =>
          setSnackbar({
            ...snackbar,
            open: false,
          })
        }
      />
    </div>
  );
}

export default LAN_BASICF;
